import {Init} from '@/core/Init'
import {Dimension, Iitem, Quad, Coord} from '@/core/main/Interface'
import {Calc} from '@/core/util/Calc'
import {Guide} from '@/core/util/Guide'
import {Params} from '@/core/services/Params'
import {Hitpoint} from '@/core/items/Hitpoint'
import {DataBase} from '@/core/services/DataBase'
import {QuoteRequest} from '@/core/services/QuoteRequest'

import {Attachable} from '@/core/items/base/Attachable'
import {Parent} from '@/core/items/base/Parent'
import {DataOffice} from '@/core/services/DataOffice'
import {DataWww} from '@/core/services/DataWww'
import {DataLibrary} from '@/core/services/DataLibrary'

import * as svgjs from '@svgdotjs/svg.js'

import {
	APP_EVT,
	SERIES_NAMES,
	INDOOR_OUTDOOR,
	USER_INTEREST,
	APP_LOCATION,
	APP_MSG,
	ITEM_ROLE,
	ITEM_TYPE,
	OPTION_TYPE,
	SERIES_ID,
	YN,
	APP_USE,
	APP_ROLE
} from '@/core/config/constants'


class Design {

	//private _stage: svgjs.Container;
	private _items: Map<string, Attachable>;

	private _inc: number;
	private _sort: any[];
	private _data: DataBase;
	private _quote_request: QuoteRequest;

	//protected _active_item: string;
	protected _unplaced_item: Attachable;

	constructor() {

		if (Init.app_role == APP_ROLE.LIBRARY) {

			this._data = new DataLibrary();

		} else {

			this._data = (Init.app_location == APP_LOCATION.OFFICE)
				? new DataOffice()
				: new DataWww();
		}

		this._quote_request = new QuoteRequest(this);

		//this._stage = Init.svg_stage;

		this._sort = [];
		this._items = new Map();

		this._inc = 0;

		Init.emitter.on(APP_EVT.MENU_ITEM_BUTTON_CLICK, this.createItem);
		Init.emitter.on(APP_EVT.HITPOINT_ROLLOVER, this.showTmpItem);
		Init.emitter.on(APP_EVT.TMP_CHILD_MOUSE_UP, this.setChildItem);
		Init.emitter.on(APP_EVT.CLICKCLIP_MOUSE_UP, this.clickclipMouseUp);
		Init.emitter.on(APP_EVT.CLICKCLIP_MOUSE_DOWN, this.clickclipMouseDown);


		Init.emitter.on(APP_EVT.RETRIEVE_SUCCESS, this.buildDesign);
		Init.emitter.on(APP_EVT.DELETE_ALL, this.removeAll);
		Init.emitter.on(APP_EVT.DELETE_ITEM, this.clickRemoveItem);
		Init.emitter.on(APP_EVT.DEACTIVATE_ITEM, this.deactivateItem);

		Init.emitter.on(APP_EVT.ITEM_PLACED, this.onDesignChanged);
		Init.emitter.on(APP_EVT.DESIGN_CHANGED, this.onDesignChanged);
		Init.emitter.on(APP_EVT.ITEM_OPTION_CHANGED, this.onDesignChanged);
		Init.emitter.on(APP_EVT.SORT_ITEMS, this.sortItems);
		Init.emitter.on(APP_EVT.SHOW_DELETE_ICON, this.showDeleteIcon);


	}


	/**
	 *
	 */
	deactivateItem = (): void => {

		if (Init.active_item != '') {
			//console.log('deactivateItem');

			// send out a call that will deactivate the active item and
			// also turn off any active hitpoints in parents
			Init.emitter.emit(APP_EVT.ITEM_PLACED, Init.active_item);

			Init.active_item = '';
			// remove our flagging that this was an unplaced item
			delete this._unplaced_item;

			this.hideDeleteIcon();

		}
	}


	/**
	 *
	 *
	 * @param data
	 */
	buildDesign = (data): void => {

		//console.log('itemdata', data.series_id, Init.series_id);

		this.removeAll();

		if (data.app_version && data.app_version == 'freestyle') {

			let params: any = {};

			let series: string = (data.series_id == SERIES_ID.FROLIC) ? 'frolic' : 'serendipity';
			let link: string = '<a href="http://designer.cedarnet.local/residential/' + series + '/' + data.design_name + '">Try old design tool?</a>';


			params.name = 'Note';
			params.message = 'This set was designed in Freestyle! It cannot be opened with this design tool.<br>' + link;
			//console.log(params);
			Guide.displayError(params);

			return;

		} else if (data.series_id != Init.series_id
			&& (data.series_id != SERIES_ID.CURVED_CLIMBER)
			&& data.series_id != SERIES_ID.OUTDOOR_PLAYHOUSE) {

			let params: any = {};

			params.name = 'Note';
			params.message = `The design "${data.design_name}" was built with the ${SERIES_NAMES[data.series_id]} design tool!<br>It cannot be opened here.`;

			Guide.displayError(params);

			return;

		}

		if (!data.design_data.items) {

			Init.emitter.emit(APP_EVT.FLASH_ERROR,
				{
					name: 'sorry',
					message: 'no design found.'
				});
			return;

		}

		//
		// let stage: any = $('#design-frame-' + Init.design_id + ' .svg-stage')[0];
		// console.log(stage);
		// this._stage = SVG.adopt(stage) as svgjs.Container;

		let itemdata: {} = data.design_data.items;
		let metadata: {} = data.design_data.meta;

		// Frolic needs to set a meta "extra_headroom" so that new items added to the set can get the value.
		// Individual items also store the headroom value as an option, in case we ever decide that
		// designs can mix extra_headroom and non extra_headroom.
		if (Init.series_id == SERIES_ID.FROLIC) {
			if (metadata && metadata['headroom']) {
				//console.log(metadata['headroom']);
				Init.emitter.emit(APP_EVT.SET_HEADROOM, metadata['headroom']);
			} else {
				Init.emitter.emit(APP_EVT.SET_HEADROOM, YN.NO);
			}
		} else if (Init.series_id == SERIES_ID.COMMERCIAL_2ANDOVER) {
			if (metadata && metadata['extender_color']) {
				Init.emitter.emit(APP_EVT.SET_EXTENDER_COLOR, metadata['extender_color']);
			}
		}


		// if this is a catalog design, set the id to null as we can then
		// force the user to save before making a quote request.
		if (Init.app_role != APP_ROLE.LIBRARY) {
			Init.design_id = (data.design_source == 'catalog' || data.design_source == 'library') ? '' : data.design_id;
		}

		if (Init.app_role != APP_ROLE.LIBRARY && data.design_source == 'library') {
			//console.log(data.design_source, SERIES_NAMES[Init.series_id] + ' ' + data.library_id);
			let library_name: string = SERIES_NAMES[Init.series_id] + ' ' + data.library_id;
			this.setDesignName(library_name);
		} else {
			this.setDesignName(data.design_name);
		}

		Init.design_timestamp = data.timestamp;

		Init.design_notes.loadNotes(data.design_data.notes);

		Init.manipulate.setGlobalScale(data.design_data.setScale);

		let grid: svgjs.Element = svgjs.SVG('#' + Init.grid_svg);
		grid.scale(Init.design_scale);


		for (let i in itemdata) {

			let itemUid: number = this.getNextItemUid();

			let item_id: number = itemdata[i].item_id;

			if (item_id == null) continue;

			// *** OVERRIDES TO FIX CHANGES TO SAVING ROUTINES *** //
			// *** PRE-LAUNCH, NEED TO RESAVE ALL CATALOG SETS BEFORE THIS CODE CAN BE REMOVED *** //
			// fence 60 is gone, so convert to default fence id
			//if (item_id == 45) item_id = 44;

			let params: Iitem = Params.getItem(item_id);

			//console.log(item_id);
			//let item = new line[params.init_class](item_id);

			try {

				let item: Attachable = Init.line.itemFactory(params.init_class, item_id);

				let itemName: string = item.init(itemUid);

				item.itemLevel = (itemdata[i].item_level == undefined) ? 1 : itemdata[i].item_level;

				// *** OVERRIDES TO FIX CHANGES TO SAVING ROUTINES *** //
				// *** PRE-LAUNCH, NEED TO RESAVE ALL CATALOG SETS BEFORE THIS CODE CAN BE REMOVED *** //
				// we now use itemLevel to show if item is ground level or not,
				// so it will be either 0 or 1, not 30 or 60.
				// item.deckHeight now stores the 30/60 data
				if (item.itemLevel == 30 || item.itemLevel == 60) item.itemLevel = 1;

				if (itemdata[i].options != undefined) {
					//console.log(itemdata[i].options);
					for (const key in itemdata[i].options) {

						let k: OPTION_TYPE = (key == 'height') ? OPTION_TYPE.ITEM_HEIGHT : Number(key);

						item.setOption(k, itemdata[i].options[key]);

					}
				}

				if (Init.app_use == APP_USE.DESIGN) {

					if (itemdata[i].roof != undefined) {

						item.setOption(OPTION_TYPE.ROOF_STYLE, itemdata[i].roof.style_id);
						item.setOption(OPTION_TYPE.ROOF_COLOR, itemdata[i].roof.color_id);
						item.setOption(OPTION_TYPE.ROOF_ROTATION, itemdata[i].roof.rotation);

					}
				}

				item.setParameters(itemdata[i]);

				//console.log(Init.design_scale, itemdata[i].r, itemdata[i].r % 5)

				if (item.itemType == ITEM_TYPE.CURVED_CLIMBER) {

					//console.log(Init.design_scale, itemdata[i].r, itemdata[i].r % 5)
					let matrix: svgjs.Matrix = new svgjs.Matrix(Init.design_scale, 0, 0, Init.design_scale, itemdata[i].x, itemdata[i].y)

					matrix = matrix.transform({rotate: itemdata[i].r})

					item.svg.matrix(matrix)

				} else {

					let m: Quad = Calc.calculateNewMatrix(Init.design_scale, itemdata[i].r)

					let matrix: svgjs.Matrix = new svgjs.Matrix(m.a, m.b, m.c, m.d, itemdata[i].x, itemdata[i].y)

					item.svg.matrix(matrix)

				}

				item.rotateLabel()

				this._items.set(itemName, item)

			} catch
				(error) {

				console.error(item_id, params, error)

			}
		}

		this.onDesignChanged();

		//console.log(Init.app_role, data.design_source);
		if (data.design_source == 'catalog' || data.design_source == 'library' || Init.app_use == APP_USE.VIEW) {

			Init.manipulate.autoCenterDesign();

		}

	}


	/**
	 *
	 */
	removeUnplacedItem = (): void => {

		if (this._unplaced_item != undefined) {
			this.removeItem(this._unplaced_item);
			delete this._unplaced_item;
			Init.active_item = '';
		}
	};


	/**
	 * creates the onstage item from a class, along with its SVG group image.
	 * If this item is the first item of the design, place it in the center of the stage.
	 * Otherwise place it in a holding location while we trigger the hitpoints
	 * to show so that the user can decide where to place the item on the playset.
	 *
	 * @param itemId
	 * @param auto
	 * @param loc
	 */
	createItem = (itemId: number, auto: boolean = false, loc?: Coord): void => {

		this.removeUnplacedItem();

		if (Init.active_item != '') {

			let item: Attachable = this._items.get(Init.active_item) as Attachable;
			//console.log('itemId', itemId, Init.active_item, item);
			Init.emitter.emit(APP_EVT.ITEM_PLACED, item);
			Init.active_item = '';
		}

		try {

			let itemUid: number = this.getNextItemUid();

			let params: Iitem = Params.getItem(itemId);

			//let item = new line[params.init_class](itemId);
			let item: Attachable = Init.line.itemFactory(params.init_class, itemId);

			//console.log(params.init_class, itemId);

			item.init(itemUid);

			//console.log(Init.active_level);
			item.itemLevel = Init.active_level;

			this._items.set(item.svgId, item);

			let m: svgjs.Matrix = item.svg.ctm()

			if (this._items.size == 1) {

				let screen_width: number = $('#design-frame').innerWidth();

				item.setMatrix(m.a, m.b, m.c, m.d, ((screen_width >> 1) - 40), 300);

				item.state = 'placed';

				Init.emitter.emit(APP_EVT.ITEM_PLACED, item)
				//Init.emitter.emit(APP_EVT.UPDATE_PACKLIST)
				Guide.displayHint(APP_MSG.SELECT_NEXT_ITEM, '', params.item_name)

			} else if (auto === true) {
				// this item is being placed automatically by the design app itself
				//console.log(loc.x, loc.y);
				item.setMatrix(m.a, m.b, m.c, m.d, loc.x, loc.y)

				item.rotation(loc.r, 0, 0)
				//Init.active_item = item.svgId
				Init.emitter.emit(APP_EVT.UPDATE_PACKLIST)

			} else if (item.itemType == ITEM_TYPE.DRAGGABLE) {

				item.setMatrix(m.a, m.b, m.c, m.d, 480, 160)

				Init.active_item = item.svgId
				Init.emitter.emit(APP_EVT.UPDATE_PACKLIST)

			} else {

				item.opacity = 0.75
				item.setTmpState()
				item.state = 'active'
				item.setMatrix(m.a, m.b, m.c, m.d, 480, 160)

				Init.emitter.emit(APP_EVT.ITEM_ACTIVE, item)

				this._unplaced_item = item;
				Init.active_item = item.svgId;

				// find out if we have any valid hitpoints for this accessory
				let targets: number = $('#design-frame .hitpoint:visible').length;

				if (targets == 0) {
					Guide.displayHint(APP_MSG.CANNOT_PLACE_ITEM, 'error', params.item_name);
				} else {
					Guide.displayHint(APP_MSG.PLACE_THE_ITEM, 'play_arrow', params.item_name, item.hitpointShape);
				}

			}

			//console.log('add item', Init.design_scale);
			item.svg.scale(Init.design_scale, Init.design_scale, 0, 0);

		} catch (e) {

			Init.reporting.report(e);

		}

	};


	removeAll = (): void => {

		for (let item of this._items.values()) {

			let id: string = item.svg.attr('id');

			item.svg.remove();

			item.destroy();

			item = null;

		}

		Init.roofs_active = false;
		Init.active_level = 1;
		Init.active_roof = null;

		this._items = new Map();
		this._sort = [];

		this._inc = 0;

		Init.emitter.emit(APP_EVT.HIDE_OPTION_STATES);


		if (Init.app_use == APP_USE.DESIGN) {
			$('#modal-delete-all').modal('hide');
		}
		this.hideDeleteIcon();

		$('#stage-codes').html('');

		Init.svg_stage.clear();
		//this._stage.clear();

	};


	clickRemoveItem = (): void => {

		if (Init.app_use == APP_USE.DESIGN) {

			if (Init.active_item == '') {

				let panel: string = '#modal-blank';

				$(panel).modal('toggle');

				$(panel + ' #msg').text('select an item to delete');

			} else {

				let item: Attachable = this._items.get(Init.active_item) as Attachable;
				this.removeItem(item);

				//Init.emitter.emit(APP_EVT.ITEM_PLACED, item);
			}
		}

	};


	removeItem = (item: Attachable): boolean => {

		item.destroy();

		let id: string = item.svg.attr('id');

		this._items.delete(id);

		Init.active_item = '';

		item.svg.remove();

		this.onDesignChanged();

		this.hideDeleteIcon();

		return true;

	};


	/**
	 * runs each time any element of the design changes, so we can
	 * calculate parents, children, codes, rules etc for this design.
	 */
	onDesignChanged = (): void => {

		Init.setAppAlert();

		Init.tmp_hitpoints_active = false

		Init.emitter.emit(APP_EVT.SHOW_BOX, ['_ybox', '_tbox']);

		$('#hint-frame').html('');

		//let time_start = Date.now();

		// let seen: string[] = [];
		// let chld45: boolean;
		this._sort = [];
		let targets: any[] = [];

		//console.trace('onDesignChanged');

		if (this._items.size == 0) return;

		for (let [chldId, chld] of this._items) {
			chld.reset();
			this._sort[chld.svgId] = chld.zindex;
		}

		for (let [itemId, itm] of this._items) {

			//console.log(itm.itemName, itm.itemRole);

			if (itm.itemRole == ITEM_ROLE.PARENT) {

				let prnt_hitpoints: string[] = Params.getHitpoints(itm.itemId);

				//console.log(prnt_hitpoints);
				let prnt: Parent = itm as Parent;

				prnt.svg.show();

				let hit_rbox: Map<string, svgjs.Box> = prnt.placeHitpoints(prnt_hitpoints);

				for (let [chldId, chld] of this._items) {

					if (prnt.svgId != chld.svgId) {

						if (chld.itemType == ITEM_TYPE.YARDARM) {

							chld.showBounds(['_tbox']);

						} else if (chld.itemType == ITEM_TYPE.DRAGGABLE) {

							continue;

						}

						let child_bbox: svgjs.Box = chld.getHitbox();

						if (Calc.noOverlap(prnt.svg.rbox(), child_bbox) === false) {
							//if (Calc.noOverlap(prnt.svg.rbox(), chld.svg.rbox()) === true) {

							//console.log('here', prnt.itemName, chld.itemName, Calc.noOverlap(prnt.svg.rbox(), chld.svg.rbox()) );

							targets = Params.getTargets(chld.itemId);

							//console.log(targets)
							// check to see if this chld can attach to this parent, that the chld is not the prnt,
							// and that we have not checked this pair of items before this loop.

							if (targets && targets[prnt.itemId]) {

								//console.log('here', prnt.itemName, chld.itemName, Calc.noOverlap(prnt.svg.rbox(), chld.svg.rbox()) );
								//console.log('here', targets[prnt.itemId].locations);
								chld.svg.show();

								// loop through the hitpoints that this child is allowed to attach to on this parent

								for (let hit_id of targets[prnt.itemId].locations) {

									//console.log(hit_id, chld.svgId, chld.getParentHitpointConditional(prnt, prnt.getHitpoint(hit_id)));
									//console.log('here', hit_id);
									if (chld.getParentHitpointConditional(prnt, prnt.getHitpoint(hit_id)) === false) {
										//console.log(prnt.itemId, chld.itemId, prnt.getHitpoint(hit_id));

										continue;
									}

									//console.log(hit_id, chld.svgId, prnt.getHitpoint(hit_id));
									// stop items attached to gazebo sides from also attaching to neighboring structures.


									if (Math.abs(chld.r % 90) == 45 && chld.xbox != null) {
										//console.log('there', hit_id);
										chld.showBounds(['_xbox']);

										if (Calc.noOverlap(chld.xbox.rbox(), hit_rbox[hit_id]) === false) {
											//console.log('here', hit_id);
											prnt.setChld(hit_id, chld);
											chld.setPrnt(hit_id, prnt);
											chld.setDeckHeight(prnt);
										}

										chld.hideBounds(['_xbox']);

									} else if (Calc.noOverlap(child_bbox, hit_rbox[hit_id]) === false) {

										//console.log(chld.r, prnt.r, prnt.getHitpoint(hit_id).r, (chld.r - (prnt.r + prnt.getHitpoint(hit_id).r)));
										// does the child rotation match the parent/hitpoint rotation?
										//let rot:number = (chld.r - (prnt.r + prnt.getHitpoint(hit_id).r));
										//console.log('there', chld.itemType, chld.r, (prnt.r + prnt.getHitpoint(hit_id).r), (rot % 360));
										// if rotation seems legit, or this is not a triangle hitpoint, move ahead
										//if ( prnt.itemType == ITEM_TYPE.CONNECTOR || (rot % 360) == 0 || chld.hitpointShape != 'triangle') {
										//if ( chld.hitpointShape != 'triangle') {

										//console.log('here', chld.svgId, hit_id, child_bbox, chld.hitpointShape);
										//console.log('here', chld.itemName, prnt.itemName);
										prnt.setChld(hit_id, chld);
										chld.setPrnt(hit_id, prnt);

										// set the itemLevel to match the parents' deck height.
										// if we are editing ground level we skip this as the itemLevel will be 0;
										//console.log('2.', prnt.svgName, chld.svgName, chld.itemLevel);
										chld.setDeckHeight(prnt);
										//}
										// disabled the break, 2021-03-17, so that structures that attach on more
										// than a single bay and get the appropriate number of roof scoops etc
										//break;
									}
								}
							}
						}

						if (chld.itemType == ITEM_TYPE.YARDARM) {

							chld.hideBounds(['_tbox']);

						}
					}
				}
				prnt.hideAllHitpoints();
				//console.log(prnt);
				//prnt.destroyAllHitpoints();
				//console.log(prnt);
			}
		}

		// need to send Activate level before we sort items to their z-index,
		// as the activation brings each item to the front.
		Init.emitter.emit(APP_EVT.ACTIVATE_LEVEL);

		for (let item of this._items.values()) {

			if (item.itemType == ITEM_TYPE.YARDARM) {

				let prnt: Parent = item.firstPrnt

				if (prnt) {
					let hitpoint: string = item.firstPrntHitpoint
					// 2025-01-14 this is clunky - we have to make sure the yardarm hitpoint is visible for Firefox, otherwise
					// we can't find the svg ctm to place the yardarm itself...'
					prnt.placeHitpoint(hitpoint, 'hitpoint-bay-spot')
					let target: Hitpoint = prnt.getHitpoint(hitpoint)
					item.setState(target)
					prnt.hideAllHitpoints();
				}
			} else {
				//console.log('design');
				item.setState();
				item.setHandles();

			}

			// if any items do not have parents it probably means something changed in the design
			// that makes their placement invalid, so we should mark them with an invalid icon.
			if ([
					ITEM_TYPE.STRUCTURE.toString(),
					ITEM_TYPE.PLAYHOUSE.toString(),
					ITEM_TYPE.DRAGGABLE.toString(),
					ITEM_TYPE.CURVED_CLIMBER.toString()
				].indexOf(item.itemType) == -1
				&& (item.firstPrnt == undefined && item.itemLevel > 0)) {
				//console.log(item, item.prnt);
				let icon:svgjs.Element = svgjs.SVG('#invalid-icon').clone();
				item.addIcon(icon);
				icon.transform({translateX: -10, translateY: -10})
			}

		}

		this.sortItems();

		Init.emitter.emit(APP_EVT.HIDE_BOX, ['_ybox', '_tbox']);

		Init.emitter.emit(APP_EVT.SET_DEPENDENCIES);

		// no need to calcualte packlist codes anywhere but the office
		if (Init.app_location == APP_LOCATION.OFFICE) {
			Init.emitter.emit(APP_EVT.UPDATE_PACKLIST);
		}

		//Init.emitter.emit(APP_EVT.SET_DECK_LABEL);
		let char: string;
		let zone: number;
		let line_2: string = '';

		switch (Init.series_id) {
			case SERIES_ID.RESIDENTIAL_INDOOR:
			case SERIES_ID.COMMERCIAL_OUTDOOR_UNDER2:
			case SERIES_ID.COMMERCIAL_INDOOR_UNDER2:
			case SERIES_ID.COMMERCIAL_2ANDOVER:
				char = '"';
				break;

			default:
				char = '\'';
				break;
		}

		let dimensions: Dimension = Init.manipulate.getDimensions(Init.svg_stage as svgjs.Container);
		let line_1: string = `playset dimensions: ${dimensions.w}${char}W x ${dimensions.d}${char}D`;

		let height: number = Init.manipulate.getDesignHeight()

		if (Init.indoor_outdoor == INDOOR_OUTDOOR.INDOOR) {
			//console.log(height);
			line_1 += ` x ${height}"H`
		} else {
			let ft: number = Math.floor(height / 12)
			let ins: number = (height % 12)
			line_1 += ` x ${ft}'${ins}"H`
		}

		if (Init.user_interest == USER_INTEREST.COMMERCIAL) {
			let zone_size: number = Init.manipulate.getUseZoneSize(Init.series_id)
			let age_range: string = Init.line.getAgeRange()
			line_2 = `use-zone dimensions: ${dimensions.w + zone_size}${char} x ${dimensions.d + zone_size}${char}`
			line_2 += `<br>age range: ${age_range}`
		}

		$('#svg-logo-box .dimensions').html(line_1 + '<br>' + line_2);

	};


	setDesignName = (design_name: string): void => {

		Init.design_name = design_name
		//localStorage.setItem('design_name', design_name);
		Init.setStorage('design_name', design_name)
		$('#svg-logo-box .design_name').text(design_name)
		$('#preview-title').text(design_name)

	}

	setSeriesId = (series_id: number): void => {

		Init.series_id = series_id

	}


	sortItems = (): void => {

		let sort = this._sort;

		let keysSorted: any = Object.keys(sort).sort(function (a, b) {
			return sort[a] - sort[b]
		});

		for (let itemId of keysSorted) {
			//console.log('-', itemId);
			this._items
				.get(itemId)
				.svg
				.front();

		}
	};

	/**
	 * set the action that occurs when the user clicks on the item.
	 * set the item as our current 'active item'.
	 * bring the item to the front of the SVG.
	 *
	 * @param item
	 * @param e
	 */
	clickclipMouseDown = (item: Attachable, e: MouseEvent): void => {

		//console.log('clickclipMouseDown', Init.keysdown);
		//disabling this 2025-04-09 to stop staff messing things up
		if (Init.keysdown.indexOf('m') != -1) {

			// M key is pressed, MOVE the item
			item.dragStart(e);

		}
	};

	/**
	 * set the action that occurs when the user clicks on the item.
	 * set the item as our current 'active item'.
	 * bring the item to the front of the SVG.
	 *
	 * @param item
	 * @param e
	 */
	clickclipMouseUp = (item: Attachable, e: MouseEvent): void => {

		//console.log('clickclipMouseUp', Init.keysdown);
		// disabling the "M to move" shortcut, 2025-04-09
		if (Init.keysdown.indexOf('m') != -1 || item.dragging === true) {

			// M key is pressed, we are MOVING the item on keydown
			item.dragEnd();

		} else if (Init.keysdown.indexOf('d') != -1) {

			// D key is pressed, DELETE the item
			this.removeItem(item);

			//} else if (Init.keysdown.indexOf('t') != -1) {
			// disabled 2025-04-08 per Barrett's request
			// T key is pressed, TURN the item
			//item.rotation(item.r + 90, 0, 0);

		} else {

			if (Init.active_item != '') {

				// let's try to stop the parent item accepting a mouseup while we try to place the tmp item
				if (Init.series_id == SERIES_ID.CURVED_CLIMBER) {
					return
				}

				let active_item: Attachable = this._items.get(Init.active_item);

				if (active_item && active_item.setInactive) {
					active_item.setInactive();
				}
			}

			if ((Init.option_mode_active == null || Init.option_mode_active == OPTION_TYPE.LEVELS)
				&& Init.active_item == item.svgId) {

				this.deactivateItem();
				this.hideDeleteIcon();

			} else if (Init.option_mode_active != null && Init.option_mode_active != OPTION_TYPE.LEVELS) {

				Init.active_item = item.svgId;
				Init.active_option_item = item;
				item.svg.front();
				item.showOptionItemActive();

			} else {

				this.deactivateItem();
				Init.active_item = item.svgId;
				item.svg.front();
				item.setTmpState();
				item.state = 'active';
				Init.emitter.emit(APP_EVT.ITEM_ACTIVE, item);
				Guide.displayHint(APP_MSG.ITEM_ACTIVE, 'play_arrow', item.itemName, item.hitpointShape);
				this.showDeleteIcon(item, e);

			}
		}
	};


	showDeleteIcon = (item: Attachable, e: MouseEvent): void => {

		let iconX: number = e.clientX + 26;
		let iconY: number = e.clientY - 22;

		$('#item-delete')
			.show()
			.offset({top: iconY, left: iconX})
			.on('mouseup', function (e: Event) {
				Init.emitter.emit(APP_EVT.DELETE_ITEM);
				e.stopPropagation();
				e.preventDefault();
			});

	};


	hideDeleteIcon = (): void => {

		$('#item-delete')
			.hide()
			.offset({top: 0, left: 0})
			.off('mouseup')

	}


	/**
	 * this function is to place structures that attach to other structures,
	 * where we can have multiple hitpoints on both parent and child.
	 * We need a way to choose the parent hitpoint, then the child hitpoint,
	 * then set the structures together in the right location, and the correct rotation.
	 *
	 * * @param child_hitpoint
	 */
	setChildItem = (child_hitpoint: Hitpoint): void => {

		let item: Parent = this._items.get(Init.active_item) as Parent

		// get rotation from target hitpoint and adjust for 180 degree rotation
		let newR: number = (Math.round(-child_hitpoint.r - 180))
		let adjX1: number = Number(child_hitpoint.x)
		let adjY1: number = Number(child_hitpoint.y)

		// item.getChildOffsetY() is required to visually bump the structure away from the final parent hitpoint
		let newX: number = (-item.offset.x - adjX1)
		let newY: number = (-(item.offset.y + item.getChildOffsetY()) - adjY1)

		//console.log(newR)
		// minimize the spin as much as possible - ie: if -270, make +90
		//if (Math.abs(newR) > 180) newR = (newR + 360) % 360
		/**
		//console.log(newX, newY, newR)
		 let loc: any = item.ctm
		// console.log(loc)
		loc.e += ((loc.c + loc.d) * newY)
		loc.f += ((loc.b + loc.a) * newX)
		item.svg
			.animate(300, 0)
			.ease('<>')
			.transform(loc)
			.transform({rotate: newR, originX: adjX1, originY: adjY1}, true)
			.after(function () {
				Init.emitter.emit(APP_EVT.ITEM_PLACED, item)
			})
		 **/
		item.svg
			.transform({relativeX: newX, relativeY: newY}, true)
			.transform({rotate: newR, originX: adjX1, originY: adjY1}, true)

		Init.emitter.emit(APP_EVT.ITEM_PLACED, item)
		item.rotateLabel()
		Init.active_item = ''
		delete this._unplaced_item

	};


	/**
	 * shows a transparent version of our child object, in place over
	 * the hitpoint, so we can see how it looks, and click the tmp image
	 * to place it on the parent item.
	 *
	 * @param hitpoint
	 */
	showTmpItem = (hitpoint: Hitpoint): void => {

		//console.log('showTmpItem', hitpoint.id);
		if (Init.active_item != '') {

			let item: Attachable = this._items.get(Init.active_item) as Attachable;

			if (item && item.setLocation) item.setLocation(hitpoint);

			this.hideDeleteIcon();

		}

	};


	/**
	 * creates a unique name for each of our items on the stage.
	 *
	 * @returns {string}
	 */
	getNextItemUid = (): number => {

		return ++this._inc;

	};

	/** **************************************************************
	 *                                   GETTERS - SETTERS
	 */

	get items()
		:
		Map<string, Attachable> {

		return this._items;

	}


}

export {
	Design
};

